import { CommonActions, useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Body1, Body2, Button, firestore, KeyboardSafeAreaScrollView, useTheme } from "capsule"
import React, { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet } from "react-native"

import { NewClientOnboardingNS } from "../../features/i18n/constants"
import { NewClientOnboardingParamList } from "../../features/Navigation/types"
import {
  clearNewClientDocId,
  getNewClientDocId,
  updateNewClientData,
} from "../../features/services/NewClientService"

const NewClientProfessionalThankYouScreen = () => {
  const { t } = useTranslation(NewClientOnboardingNS)
  const navigation =
    useNavigation<
      StackNavigationProp<NewClientOnboardingParamList, "NewClientProfessionalThankYou">
    >()

  const {
    colors: {
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()

  const s = useMemo(
    () => ({
      container: [
        styles.container,
        {
          backgroundColor: background,
        },
      ],
      innerContent: {
        paddingVertical: spacing * 4,
        paddingHorizontal: spacing * 2,
        gap: spacing * 2,
      },
      inputContainer: {
        paddingHorizontal: spacing,
      },
      child: {
        marginTop: spacing,
      },
    }),
    [background, spacing],
  )

  useEffect(() => {
    const finalize = async () => {
      const docId = await getNewClientDocId()
      await updateNewClientData(docId, {
        completedAt: firestore.Timestamp.now(),
        status: "completed",
      })
    }
    finalize()
  }, [])

  const onBackToHome = async () => {
    await clearNewClientDocId()

    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "Welcome" }],
      }),
    )
  }

  return (
    <KeyboardSafeAreaScrollView style={s.container} contentContainerStyle={s.innerContent}>
      <Body1 style={styles.bold}>{t("professionalThankYou.title")}</Body1>

      <Body1 style={styles.bold}>{t("professionalThankYou.message")}</Body1>

      <Body2>{t("professionalThankYou.info")}</Body2>

      <Button style={s.child} mode="contained" onPress={onBackToHome} testID="button_back_home">
        {t("professionalThankYou.button")}
      </Button>
    </KeyboardSafeAreaScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  bold: {
    fontWeight: "bold",
  },
})

export default NewClientProfessionalThankYouScreen
